
















































































































import { Component, Vue } from "vue-property-decorator";
import request from "@/api/wanzhou/index";
import Base from "@/template/public/Base.vue";
import NewsItem from "@/components/NewsItemLeft.vue";
import { IVideoDetail, ICommonItem } from "@/api/wanzhou/types";
import { IShareConfig, IShareConfigItem } from "@/api/types";
// import { AppInfo } from "@/common/baseConfig";
import Zan from "@/components/Zan.vue";
import native from "@/common/Native";
import AppPrompt from "@/components/AppPrompt.vue";
import { wxChatShare } from "@/common/wechat";
import { Loading, Toast } from "vant";
import { setImgSrc, findNameByIdInApp } from "@/common/Utils";
import nopage from "@/components/404.vue";
import ImageViewCom from "@/components/imageViewCom.vue";
import posterV2 from "@/components/posterV2.vue";
import { getData, time } from "@/common/dataCollect";
@Component({
  components: {
    Zan,
    AppPrompt,
    VanLoading: Loading,
    NewsItem,
    nopage,
    ImageViewCom,
    posterV2
  }
})
export default class VideoPage extends Base {
  request = new request();
  videoDetail: ICommonItem | null | any = null;
  isPraise = false;
  downloadUrl = "";
  private appName = "";
  public appId: string = "";
  hotNewsList: ICommonItem[] = [];
  private userInfo: any = {
    token: "",
    sessionId: "",
    phone: ""
  };
  private businessDetail: any = {
    isPraised: "",
    viewCount: "",
    praiseCount: "",
    replyCount: ""
  };
  private isOpenInApp: boolean = false;
  private isRequestLoaded: boolean = false; //详情是否加载完成
  ImgSrcArr: any = [];
  get praiseImg() {
    if (this.isPraise) {
      return require("../../../assets/已点赞@2x.png");
    } else {
      return require("../../../assets/形状 27.png");
    }
  }
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  isWaterMarker: boolean = false;
  created() {
    this.startTime = time();
  }
  mounted() {
    if (Object.keys(this.$route.query).includes("k")) {
      this.isWaterMarker = true;
    }
    this.infoClassifyId = this.$route.query.id
      ? (this.$route.query.id as string)
      : (this.$route.query.cid as string) || "2273453";
    this.appId = (this.$route.query.appId as string) || "28";
    // this.appName = AppInfo[Number(this.appId)]; //enum 反向映射
    this.appName = findNameByIdInApp(this.$store.state.appInfo, this.appId); //enum 反向映射
    //获取用户详情
    if (native.isOpenInApp()) {
      native.getUserInfo().then((response: any) => {
        this.userInfo = response;
        this.getDetail();
        this.isOpenInApp = true;
      });
    } else {
      this.getDetail();
      this.isOpenInApp = false;
    }
  }
  getDetail() {
    this.request
      .getNewsDetails(this.infoClassifyId)
      .then(response => {
        this.isRequestLoaded = true;
        if (response.code >= 0) {
          this.videoDetail = response.data;
          document.title = this.videoDetail.title;
          // this.$nextTick(() => {
          //   this.makePoster();
          // })
          this.getBussinessDetail();
          this.getCount();

          // 唤醒头部 赋值base.vue里detailGetAppId参数值
          this.getBaseappInfoConfigList(this.videoDetail.appId);
          this.detailGetAppId = this.videoDetail.appId;
          this.getHotNewsList();
          this.$nextTick(() => {
            setImgSrc(this.$refs.newsContent as Element);
            this.handleVideo();
            this.imageHandle(); // 图片预览等功能

            // 埋点
            this.endTime = time();
            if (this.dataSource) {
              getData(this.startTime, this.endTime, this.videoDetail);
              this.dataSource = false;
            }
          });
        }
      })
      .catch(() => {
        this.getShareInfo(this.appId);
        this.isRequestLoaded = true;
      });
  }
  // 图片处理
  openViewChild(index: any) {
    const el = this.$refs.ImageViewCom as any;
    el.openView(index);
  }
  imageHandle() {
    const elements: Array<HTMLElement> = Array.prototype.slice.call(
      document.querySelectorAll(".news-content img") as NodeListOf<HTMLElement>,
      0
    );
    const srcArr: Array<string> = elements.map(
      v => v.getAttribute("data-original") as string
    );
    this.ImgSrcArr = srcArr;
    let th = this;
    elements.forEach((v, i) => {
      (function(i) {
        v &&
          v.addEventListener(
            "click",
            function(e) {
              th.openViewChild(i);
            },
            false
          );
      })(i);
    });
  }
  /**业务详情 */
  getBussinessDetail() {
    this.request
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        // this.newsInfo.informationId,
        this.infoClassifyId,
        "1",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response.code >= 0) {
          this.isPraise = response.data.isPraised;
          // this.businessDetail = response.data;
          wxChatShare(
            response.data.detailTitle,
            response.data.shareDescription,
            response.data.shareUrlWx,
            response.data.shareImgUrl
          );
        }
      });
  }

  getCount() {
    // 在app外才需要增加浏览量 接口做了ua判断不需要前端判断是否在app内
    this.request.getCount(this.appId, this.infoClassifyId).then((res: any) => {
      if (res.code >= 0 && res.data) {
        this.businessDetail.viewCount = res.data.showViewCount;
        this.businessDetail.praiseCount = res.data.showPraiseCount;
        this.businessDetail.replyCount = res.data.showReplyCount;
      }
    });
  }
  // 点赞
  praise() {
    this.request
      .getpraiseShare(this.appId, this.videoDetail!.informationId, "1")
      .then(res => {
        if (res.code >= 0 && res.data) {
          this.businessDetail.praiseCount =
            Number(this.businessDetail.praiseCount) + 1;
        } else {
          Toast(res.message);
        }
      });
  }

  download() {
    window.location.href = this.shareInfo.downloadUrl;
  }

  async getIsPraise() {
    const result = await this.request.isPraised(
      this.videoDetail!.appId,
      this.userInfo.sessionId,
      this.userInfo.token,
      "1",
      this.videoDetail!.informationId,
      "1"
    );
    this.isPraise = result.data;
  }

  doPraiseShare() {
    if (!native.isOpenInApp()) {
      return this.download();
    }
    if (this.isPraise) {
      return;
    }
    return this.request
      .doPraise(
        this.infoClassifyId,
        this.videoDetail!.appId,
        this.userInfo.sessionId,
        this.videoDetail!.informationId,
        this.videoDetail!.sourceType,
        "1",
        0,
        this.userInfo.token,
        new Date().format()
      )
      .then((result: any) => {
        if (result.data) {
          if (result.data.isSuccess) {
            isNaN(Number(this.businessDetail!.praiseCount))
              ? ""
              : (this.businessDetail!.praiseCount =
                  Number(this.businessDetail!.praiseCount) + 1);
            this.isPraise = true;
          } else {
            Toast(result.data.message);
          }
        } else {
          Toast(result.message);
        }
      });
  }

  getHotNewsList() {
    this.request
      .getHotList(this.infoClassifyId, this.videoDetail!.appId)
      .then(result => {
        this.hotNewsList = result.data.dataList;
      });
  }

  itemClick(item: ICommonItem) {
    if (native.isOpenInApp()) {
      native.openWebBrowser({
        id: item.id,
        sourceId: item.informationId,
        detailViewType: item.detailViewType,
        sourceType: item.sourceType,
        commentType: item.commentType,
        contextType: item.contextType,
        isShowTop: "1",
        isShowBottom: "1",
        isShowMore: "1",
        url: item.url,
        shareUrl: item.shareUrl,
        title: item.title, //base 64
        synopsis: item.synopsis, //base 64
        shareImgUrl: item.shareImgUrl,
        videoFormat: item.videoFormat ? item.videoFormat : ""
      });
    } else {
      window.open(item.url);
    }
  }
}
